function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOm = function SvgOm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 85.333 512 341.333",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M512,200.093H0V97.104c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828 L512,200.093L512,200.093z"
  }), React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M503.172,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.909h512v102.988 C512,419.773,508.047,423.725,503.172,423.725z"
  }), React.createElement("g", null, React.createElement("rect", {
    y: 200.091,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 111.81
  }), React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M132.414,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V97.104c0-4.875,3.953-8.828,8.828-8.828 h123.586V423.725z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M36.056,161.444c-0.494,0.056-0.971,0.116-1.436,0.178v6.287c0.468,0.119,0.945,0.237,1.436,0.353 V161.444z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M57.803,173.427c-1.311-0.105-3.325-0.307-5.729-0.6l-15.079,13.411 c1.953,0.298,4.294,0.694,5.271,1.005C46.141,183.853,51.335,179.234,57.803,173.427z"
  }), React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "80.491,152.097 80.491,151.437 80.491,150.806 53.739,150.806 53.739,151.437  53.739,152.097 53.739,152.729 80.491,152.729  "
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M60.685,113.837c0,1.884,2.839,3.475,6.2,3.475s6.2-1.591,6.2-3.475c0-1.884-2.839-3.475-6.2-3.475 C63.524,110.362,60.685,111.954,60.685,113.837z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M54.887,160.594c-6.039-0.03-12.066,0.192-16.993,0.658v7.422 c5.789,1.242,12.533,2.194,16.993,2.668C54.887,171.341,54.887,160.594,54.887,160.594z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M23.776,197.221c2.387-0.051,7.63-0.994,11.18-3.767c1.1-0.86,2.979-2.442,5.62-4.736 c-1.791-0.367-4.796-0.813-6.398-1.033L23.776,197.221z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.332,148.969v-3.374c-0.452-0.674-0.919-1.369-1.396-2.076l-4.107,2.987 c0.818,1.405,1.342,2.298,1.439,2.462L58.332,148.969L58.332,148.969z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M26.728,164.204c-0.013,0.055-0.045,0.183,0.161,0.448c0.762,0.977,2.967,1.91,5.895,2.759v-5.516 C29.269,162.478,26.967,163.248,26.728,164.204z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M73.717,161.57v-7.004H60.169v17.108h3.445C69.184,171.674,73.717,167.14,73.717,161.57z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M51.942,136.128c-7.254-10.692-15.001-21.93-16.892-24.157c0.271,0.995,0.925,2.865,2.453,6.366 c1.971,4.518,6.755,13.177,10.716,20.149L51.942,136.128z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M49.129,140.085c1.032,1.806,1.977,3.448,2.774,4.824l4.007-2.914 c-0.953-1.415-1.934-2.866-2.935-4.344L49.129,140.085z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.332,171.641v-11.004c-0.535-0.011-1.07-0.022-1.608-0.029v10.913 C57.343,171.575,57.882,171.616,58.332,171.641z"
  }), React.createElement("rect", {
    x: 60.17,
    y: 139.521,
    style: {
      fill: "#F5F5F5"
    },
    width: 13.549,
    height: 1.923
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M92.547,148.854v0.115h0.689c0.508,0,0.918,0.41,0.918,0.918v3.761c0,0.508-0.41,0.918-0.918,0.918 h-0.689v0.115c0,0.505,0.412,0.918,0.918,0.918h15.5c0.506,0,0.918-0.413,0.918-0.918v-5.827c0-0.505-0.412-0.918-0.918-0.918 H93.466C92.959,147.935,92.547,148.347,92.547,148.854z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M109.89,197.17l-10.345-9.485c-1.602,0.221-4.606,0.665-6.398,1.033 c2.689,2.333,4.567,3.915,5.62,4.738C102.262,196.184,107.398,197.141,109.89,197.17z"
  }), React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "88.643,151.437 88.643,152.097 88.643,152.729 92.318,152.729 92.318,150.806  88.643,150.806  "
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M91.454,187.245c0.977-0.313,3.321-0.71,5.278-1.007l-22.214-19.823 c-0.602,1.352-1.442,2.575-2.476,3.606l0.585,0.522C80.674,177.747,86.965,183.325,91.454,187.245z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M41.683,154.681v-0.115h-0.69c-0.508,0-0.918-0.41-0.918-0.918v-3.761 c0-0.508,0.41-0.918,0.918-0.918h0.689v-0.115c0-0.505-0.412-0.918-0.918-0.918h-15.5c-0.506,0-0.918,0.413-0.918,0.918v5.827 c0,0.505,0.412,0.918,0.918,0.918h15.5C41.271,155.599,41.683,155.187,41.683,154.681z"
  }), React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "45.587,152.097 45.587,151.437 45.587,150.806 41.912,150.806 41.912,152.729  45.587,152.729  "
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M80.895,146.506l-4.107-2.987c-0.42,0.625-0.831,1.236-1.234,1.835v3.614h3.902 C79.553,148.804,80.077,147.911,80.895,146.506z"
  }), React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "61.398,133.899 72.493,133.899 70.051,131.189 63.84,131.189  "
  }), React.createElement("rect", {
    x: 60.17,
    y: 135.821,
    style: {
      fill: "#F5F5F5"
    },
    width: 13.549,
    height: 1.866
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M66.886,119.149c-0.893,0-1.73-0.115-2.526-0.285v10.383h5.109v-10.394 C68.657,119.031,67.799,119.149,66.886,119.149z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M60.169,145.208h13.49c-0.002-0.115,0.018-0.227,0.06-0.338v-1.585h-13.55V145.208z"
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M77.815,141.995l4.007,2.914c0.797-1.375,1.742-3.018,2.774-4.824l-3.846-2.434 C79.748,139.129,78.769,140.58,77.815,141.995z"
  }), React.createElement("rect", {
    x: 60.17,
    y: 147.051,
    style: {
      fill: "#F5F5F5"
    },
    width: 13.549,
    height: 1.923
  }), React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M85.506,138.486c3.96-6.97,8.744-15.631,10.716-20.149c1.532-3.509,2.185-5.38,2.455-6.372 c-1.857,2.179-9.623,13.443-16.895,24.163L85.506,138.486z"
  })), React.createElement("path", {
    style: {
      fill: "#D23741"
    },
    d: "M112.449,197.024l-11.979-10.985c-0.201-0.184-0.472-0.275-0.744-0.233 c-0.102,0.013-0.333,0.045-0.64,0.087c-0.017-0.017-0.023-0.04-0.042-0.055l-23.877-21.307c0.244-0.949,0.386-1.938,0.386-2.961 v-7.004h5.792c0.746,0.971,1.906,1.608,3.221,1.608c1.316,0,2.476-0.637,3.221-1.608h2.922v0.115c0,1.519,1.236,2.755,2.755,2.755 h15.5c1.519,0,2.755-1.236,2.755-2.755v-5.827c0-1.519-1.236-2.755-2.755-2.755H93.466c-1.519,0-2.755,1.236-2.755,2.755v0.115 h-2.922c-0.746-0.971-1.906-1.608-3.221-1.608c-0.998,0-1.9,0.374-2.609,0.97c3.096-5.3,12.823-22.1,15.947-29.259 c3.351-7.682,3.081-8.674,2.289-9.311c-0.836-0.669-1.894,0.1-2.293,0.393c-1.537,1.117-16.44,23.134-22.348,31.91v-7.246 c0-0.02-0.01-0.038-0.011-0.057l-0.001-0.002c-0.021-0.311-0.195-0.57-0.449-0.719l-3.787-4.2v-11.549 c2.19-0.94,3.617-2.564,3.617-4.454c0-2.978-3.531-5.312-8.038-5.312s-8.038,2.334-8.038,5.312c0,1.905,1.453,3.538,3.674,4.473 v11.596l-3.715,4.121c-0.279,0.158-0.476,0.446-0.476,0.789v7.486c-5.793-8.607-20.959-31.022-22.508-32.149 c-0.401-0.29-1.46-1.06-2.294-0.393c-0.793,0.637-1.063,1.629,2.289,9.311c3.025,6.932,12.238,22.899,15.631,28.719 c-0.542-0.267-1.143-0.43-1.786-0.43c-1.316,0-2.476,0.637-3.221,1.608H43.52v-0.115c0-1.519-1.236-2.755-2.755-2.755H25.263 c-1.519,0-2.755,1.236-2.755,2.755v5.827c0,1.519,1.236,2.755,2.755,2.755h15.5c1.519,0,2.755-1.236,2.755-2.755v-0.115h2.922 c0.746,0.971,1.906,1.608,3.221,1.608c1.316,0,2.476-0.637,3.221-1.608h5.448v4.23c-8.516-0.182-32.093-0.21-33.385,4.963 c-0.12,0.479-0.132,1.222,0.495,2.024c2.485,3.183,15.079,5.506,24.214,6.734l-14.976,13.32c-0.019,0.017-0.025,0.04-0.043,0.057 c-0.307-0.043-0.538-0.074-0.64-0.087c-0.276-0.04-0.544,0.049-0.744,0.233l-11.98,10.985c-0.362,0.33-0.399,0.888-0.084,1.265 c0.397,0.477,1.406,0.711,2.755,0.711c3.32,0,8.707-1.416,12.141-4.097c2.83-2.21,10.67-9.084,23.304-20.43 c0.547-0.491,0.909-0.817,1.069-0.96h3.154c2.621,0,5.038-0.858,7.01-2.295l0.778,0.695c14.546,13.02,23.372,20.754,26.237,22.99 c3.434,2.684,8.819,4.097,12.139,4.097c1.35,0,2.358-0.233,2.756-0.711C112.849,197.912,112.81,197.354,112.449,197.024z  M60.169,171.674v-17.108h13.549v7.004c0,5.57-4.533,10.104-10.104,10.104H60.169z M32.785,167.411 c-2.926-0.85-5.132-1.782-5.895-2.759c-0.207-0.266-0.175-0.393-0.161-0.448c0.239-0.956,2.541-1.726,6.056-2.308V167.411z  M35.05,111.971c1.89,2.227,9.638,13.463,16.892,24.157l-3.724,2.358c-3.96-6.972-8.744-15.631-10.716-20.149 C35.975,114.837,35.32,112.968,35.05,111.971z M56.936,143.519c0.476,0.706,0.942,1.4,1.396,2.076v3.374h-4.064 c-0.097-0.164-0.621-1.057-1.439-2.462L56.936,143.519z M51.902,144.909c-0.797-1.375-1.742-3.018-2.774-4.824l3.846-2.434 c1.002,1.479,1.982,2.93,2.935,4.344L51.902,144.909z M58.332,160.638v11.004c-0.448-0.025-0.988-0.066-1.608-0.12v-10.913 C57.261,160.616,57.796,160.626,58.332,160.638z M37.894,161.251c4.928-0.466,10.954-0.687,16.993-0.658v10.748 c-4.46-0.473-11.204-1.426-16.993-2.668V161.251z M34.621,161.622c0.465-0.062,0.941-0.121,1.436-0.178v6.817 c-0.491-0.115-0.968-0.233-1.436-0.353C34.621,167.908,34.621,161.622,34.621,161.622z M52.074,172.826 c2.404,0.294,4.418,0.495,5.729,0.6c-6.468,5.807-11.662,10.426-15.535,13.816c-0.978-0.312-3.318-0.707-5.271-1.005L52.074,172.826 z M40.576,188.717c-2.641,2.294-4.52,3.876-5.62,4.736c-3.55,2.774-8.792,3.718-11.18,3.767l10.402-9.537 C35.78,187.905,38.784,188.35,40.576,188.717z M53.739,152.729v-0.631v-0.66v-0.631h26.753v0.631v0.66v0.631H53.739z  M73.086,113.837c0,1.884-2.839,3.475-6.2,3.475s-6.2-1.591-6.2-3.475c0-1.884,2.839-3.475,6.2-3.475S73.086,111.954,73.086,113.837 z M60.169,141.448v-1.923h13.549v1.923H60.169z M73.717,143.285v1.585c-0.042,0.111-0.062,0.223-0.06,0.338H60.169v-1.923H73.717 C73.717,143.285,73.717,143.285,73.717,143.285z M60.169,137.687v-1.866h13.549v1.866H60.169z M70.051,131.189l2.442,2.709H61.398 l2.442-2.709H70.051z M64.36,129.248v-10.383c0.796,0.17,1.633,0.285,2.526,0.285c0.914,0,1.771-0.118,2.583-0.296v10.394H64.36z  M60.169,147.045h13.549v1.923H60.169V147.045z M96.222,118.337c-1.971,4.518-6.755,13.177-10.716,20.149l-3.724-2.358 c7.272-10.72,15.038-21.984,16.895-24.163C98.407,112.957,97.753,114.828,96.222,118.337z M86.806,151.437v0.66 c0,1.235-1.004,2.239-2.239,2.239s-2.239-1.004-2.239-2.239v-0.66c0-1.235,1.004-2.239,2.239-2.239S86.806,150.202,86.806,151.437z  M81.822,144.909l-4.007-2.914c0.953-1.415,1.933-2.866,2.935-4.344l3.846,2.434C83.564,141.891,82.618,143.533,81.822,144.909z  M75.554,145.354c0.403-0.6,0.813-1.21,1.234-1.835l4.107,2.987c-0.818,1.405-1.342,2.298-1.439,2.463h-3.902V145.354z  M74.518,166.413l22.214,19.823c-1.955,0.299-4.301,0.695-5.278,1.007c-4.49-3.921-10.78-9.497-18.828-16.703l-0.585-0.522 C73.076,168.989,73.916,167.765,74.518,166.413z M99.546,187.684l10.345,9.485c-2.493-0.029-7.628-0.985-11.123-3.714 c-1.053-0.823-2.931-2.406-5.62-4.738C94.94,188.35,97.944,187.905,99.546,187.684z M109.886,148.854v5.827 c0,0.505-0.412,0.918-0.918,0.918H93.466c-0.506,0-0.918-0.413-0.918-0.918v-0.115h0.689c0.508,0,0.918-0.41,0.918-0.918v-3.761 c0-0.508-0.41-0.918-0.918-0.918h-0.689v-0.115c0-0.505,0.412-0.918,0.918-0.918h15.5 C109.473,147.935,109.886,148.347,109.886,148.854z M92.318,152.729h-3.674v-0.631v-0.66v-0.631h3.674V152.729z M24.344,154.681 v-5.827c0-0.505,0.412-0.918,0.918-0.918h15.5c0.506,0,0.918,0.413,0.918,0.918v0.115h-0.687c-0.508,0-0.918,0.41-0.918,0.918v3.761 c0,0.508,0.41,0.918,0.918,0.918h0.689v0.115c0,0.505-0.412,0.918-0.918,0.918h-15.5C24.757,155.599,24.344,155.187,24.344,154.681z  M41.912,150.806h3.674v0.631v0.66v0.631h-3.674V150.806z M51.902,152.097c0,1.235-1.004,2.239-2.239,2.239 c-1.235,0-2.239-1.004-2.239-2.239v-0.66c0-1.235,1.004-2.239,2.239-2.239c1.235,0,2.239,1.004,2.239,2.239V152.097z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OM.95a90c5a.svg";
export { ForwardRef as ReactComponent };